import { render, staticRenderFns } from "./socialTab.vue?vue&type=template&id=46042d11&"
import script from "./socialTab.vue?vue&type=script&lang=js&"
export * from "./socialTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports